import React from "react";
import { Link } from "react-router-dom";

const TransactionsTable = ({ headers, data, isMMTransaction, isPMTransaction, cancelTransaction }) => {
  return (
    <table className="table display data-table text-nowrap">
      <thead>
        <tr>
          {headers.map((header, index) => (
            <th key={index} style={{ width: header.width || "auto" }}>
              {header.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.length > 0 ? (
          data.map((item, index) => (
            <tr key={index}>
              {headers.map((header, headerIndex) => {
                const value = item[header.key]; // Get the value based on the key
                
                // Handle special cases
                if (header.key === "created_at") {
                  return (
                    <td key={headerIndex}>
                      {item.created_at?.short_date || "Date not available"}
                      <br />
                      <small>{item.created_at?.time || "Time not available"}</small>
                    </td>
                  );
                }

                if (header.key === "termly_created_at") {
                  return (
                    <td key={headerIndex}>
                      {item.created_at?.short_date || "Date not available"}
                    </td>
                  );
                }

                if (header.key === "cm_created_at") {
                  return (
                    <td key={headerIndex}>
                      {item.created_at?.long_date || "Date not available"}
                    </td>
                  );
                }

                if (header.key === "student" || header.key === "user") {
                  return (
                    <td key={headerIndex}>
                      {item.student || item.user || "Unknown User"}
                      <br />
                      <small>{item.school || item.username || "Parent"}</small>
                    </td>
                  );
                }

                if (header.key === "student_name") {
                  return (
                    <td key={headerIndex}>
                      {item.student || item.user || "Unknown User"}
                    </td>
                  );
                }

                if (header.key === "amount" || header.key === "cash_in" || header.key === "cash_out") {
                  // For MM transactions, show default "SUCCESSFUL"
                  if (isMMTransaction) {
                    return (
                      
                      <td key={headerIndex}>
                      <span className="badge bg-teal">
                        <i className="fa fa-circle text-teal fs-9px fa-fw me-5px" style={{ color: "#042954" }}></i>
                        UGX. {item[header.key]}
                      </span>
                      <br />
                     
                      <span className={`badge ${item.status === "3" ? "badge-success" : item.status === "1" ? "badge-warning" : "badge-danger"}`}>
                        {item.status === "3" ? "SUCCESSFUL" : item.status === "1" ? "PENDING" : "FAILED"}
                      </span>
                    </td>
                    );
                  }
                  else if(isPMTransaction){
                    return (
                      <td key={headerIndex}>
                        <span className="badge bg-teal">
                          <i className="fa fa-circle text-teal fs-9px fa-fw me-5px" style={{ color: "#042954" }}></i>
                          UGX. {item[header.key]}
                        </span>
                        <br />
                        <small>
                          {item.description}
                        </small> 
                      </td>
                    );

                  } else {
                    return (
                      <td key={headerIndex}>
                        <span className="badge bg-teal">
                          <i className="fa fa-circle text-teal fs-9px fa-fw me-5px" style={{ color: "#042954" }}></i>
                          UGX. {item[header.key]}
                        </span>
                        <br />
                        <span className="badge badge-success">SUCCESSFUL</span> 
                      </td>
                    );
                  }
                }

                if (header.key === "amount_invoiced") {
                  return (
                    <td key={headerIndex}>
                      <span className="badge bg-teal">
                        <i className="fa fa-circle text-teal fs-9px fa-fw me-5px" style={{ color: "#042954" }}></i>
                        UGX. {item.amount}
                      </span>
                    </td>
                  );
                }

                if (header.key === "cm_description") {
                  return (
                    <td key={headerIndex}>
                      {item.description}
                    </td>
                  );
                }

                if (header.key === "balance") {
                  return (
                    <td key={headerIndex}>
                      <span className="badge bg-teal">
                        <i className="fa fa-circle text-teal fs-9px fa-fw me-5px" style={{ color: "#042954" }}></i>
                        UGX. {item.invoice_balance}
                      </span>
                    </td>
                  );
                }

                if (header.key === "status") {
                  return (
                    <td key={headerIndex}>
                      <span className={`badge ${item.status === "3" ? "badge-success" : item.status === "1" ? "badge-warning" : "badge-danger"}`}>
                        {item.status === "3" ? "SUCCESSFUL" : item.status === "1" ? "PENDING" : "FAILED"}
                      </span>
                    </td>
                  );
                }

                if (header.key === "account") {
                    return (
                      <td key={headerIndex}>
                        <span className="badge badge-info">{item.account || "N/A"}</span>
                      </td>
                    );
                  }

                if (header.key === "internal_ref" || header.key === "transaction_number" || header.key === "client_ref") {
                  return <td key={headerIndex}>{item[header.key] || "N/A"}</td>;
                }

                if (header.key === "transactors"){
                  return (
                    <td key={headerIndex}>
                      
                      {item.transactors.length === 2 ? (
                        <>
                          {item.transactors[0]?.cash_in === "0"? <i className="fa fa-angles-down mr-2" style={{color:"red"}}></i>:<i className="fa fa-angles-up mr-2" style={{color:"green"}}></i>} {item.transactors[0]?.user} <br/>
                          {item.transactors[1]?.cash_in === "0"? <i className="fa fa-angles-down mr-2" style={{color:"red"}}></i>:<i className="fa fa-angles-up mr-2" style={{color:"green"}}></i>} {item.transactors[1]?.user}
                        </>
                      ) : (
                        <>
                        {item.transactors[0]?.cash_in === "0"? <i className="fa fa-angles-down mr-2" style={{color:"red"}}></i>:<i className="fa fa-angles-up mr-2" style={{color:"green"}}></i>}<span> {item.transactors[0]?.user}</span>
                        </>
                      )}
                    </td>
                  );
                }

                if (header.key === "termly_status") {
                    return (
                      <td key={headerIndex}>
                        {item.invoice_status === "PAID"?
                          <i className="fa fa-circle-check text-teal fs-9px fa-fw me-5px"style={{ color: "#28a745" }}></i>
                          :<i className="fa fa-hourglass-half text-teal fs-9px fa-fw me-5px" style={{ color: "#ffc107" }} ></i>
                        }</td>
                    );
                  }

                if (header.key === "actions") {
                  return <td key={headerIndex}>
                                  <div className="dropdown">
                                    <Link
                                      to="#"
                                      className="dropdown-toggle"
                                      data-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <span className="flaticon-more-button-of-three-dots"></span>
                                    </Link>
                                    <div className="dropdown-menu dropdown-menu-right">
                                      {item.status === "1" ? (
                                        <Link
                                          className="dropdown-item"
                                          to="#"
                                          onClick={(e) => cancelTransaction(e, item)}
                                        >
                                          <i
                                            className="fa fa-circle-xmark mr-1"
                                            style={{ color: "red" }}
                                          ></i>
                                          Cancel Transaction
                                        </Link>
                                      ) : (
                                        <Link className="dropdown-item" to="#">
                                          
                                          Transaction Finalized
                                        </Link>
                                      )}
                                    </div>
                                  </div>
                                </td>;
                }

                // Default case for other fields
                return <td key={headerIndex}>{value || "N/A"}</td>;
              })}
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={headers.length} style={{ textAlign: "center" }}>
              No transactions found.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default TransactionsTable;
